module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "measure"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('m-column', {
    staticClass: "form",
    attrs: {
      "title": "保费测算"
    }
  }, [_c('div', {
    staticClass: "right",
    slot: "right"
  }, [_c('span', {
    on: {
      "click": function () {
        this$1.$emit('close')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    ref: "measureBody",
    staticStyle: {
      "overflow": "auto"
    },
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_vm._l((_vm.measureForm), function(form, index) {
    return [(form.type === 'insuredRelations') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_c('m-candidate', {
      attrs: {
        "list": _vm.insuredRelations
      },
      on: {
        "change": _vm.changeRnsuredRelation
      },
      model: {
        value: (_vm.insuredRelation),
        callback: function($$v) {
          _vm.insuredRelation = $$v
        },
        expression: "insuredRelation"
      }
    })], 1) : _vm._e(), _vm._v(" "), (form.type === 'birthday') ? _c('datetime', {
      key: index,
      attrs: {
        "default-selected-value": _vm.defaultSelectedValue,
        "min-year": 1900,
        "start-date": _vm.birthdayConstraints.startDate,
        "end-date": _vm.birthdayConstraints.endDate,
        "confirm-text": "确定",
        "cancel-text": "取消",
        "title": form.name,
        "placeholder": _vm.birthdayConstraints.placeholder
      },
      on: {
        "on-change": _vm.getFee
      },
      model: {
        value: (_vm.birthday),
        callback: function($$v) {
          _vm.birthday = $$v
        },
        expression: "birthday"
      }
    }) : _vm._e(), _vm._v(" "), (form.type === 'sexs') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_c('m-candidate', {
      attrs: {
        "list": _vm.sexs
      },
      on: {
        "change": _vm.getFee
      },
      model: {
        value: (_vm.sex),
        callback: function($$v) {
          _vm.sex = $$v
        },
        expression: "sex"
      }
    })], 1) : _vm._e(), _vm._v(" "), (form.type === 'coverages') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_c('m-candidate', {
      attrs: {
        "list": _vm.coverages
      },
      on: {
        "change": _vm.getFee
      },
      model: {
        value: (_vm.coverage),
        callback: function($$v) {
          _vm.coverage = $$v
        },
        expression: "coverage"
      }
    })], 1) : _vm._e(), _vm._v(" "), (form.type === 'paymentPeriods') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_c('m-candidate', {
      attrs: {
        "list": _vm.paymentPeriods
      },
      on: {
        "change": _vm.getFee
      },
      model: {
        value: (_vm.paymentPeriod),
        callback: function($$v) {
          _vm.paymentPeriod = $$v
        },
        expression: "paymentPeriod"
      }
    })], 1) : _vm._e(), _vm._v(" "), (form.type === 'insurancePeriods') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_c('m-candidate', {
      attrs: {
        "list": _vm.insurancePeriods
      },
      on: {
        "change": _vm.getFee
      },
      model: {
        value: (_vm.insurancePeriod),
        callback: function($$v) {
          _vm.insurancePeriod = $$v
        },
        expression: "insurancePeriod"
      }
    })], 1) : _vm._e(), _vm._v(" "), (form.type === 'paymentWays') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_c('m-candidate', {
      attrs: {
        "list": _vm.paymentWays
      },
      on: {
        "change": _vm.getFee
      },
      model: {
        value: (_vm.paymentWay),
        callback: function($$v) {
          _vm.paymentWay = $$v
        },
        expression: "paymentWay"
      }
    })], 1) : _vm._e(), _vm._v(" "), (form.type === 'paymentModes') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_c('m-candidate', {
      attrs: {
        "list": _vm.paymentModes
      },
      on: {
        "change": _vm.changePaymentMode
      },
      model: {
        value: (_vm.paymentMode),
        callback: function($$v) {
          _vm.paymentMode = $$v
        },
        expression: "paymentMode"
      }
    })], 1) : _vm._e(), _vm._v(" "), (form.type === 'copies') ? _c('x-number', {
      key: index,
      attrs: {
        "fillable": true,
        "title": form.name + '（' + (_vm.paymentMode === 1 ? '1000' : '100') + '元/份）',
        "width": "40px",
        "min": _vm.copiesMin,
        "max": _vm.copiesMax,
        "step": form.constraints.step
      },
      on: {
        "on-change": _vm.getFee
      },
      model: {
        value: (_vm.coverage),
        callback: function($$v) {
          _vm.coverage = $$v
        },
        expression: "coverage"
      }
    }) : _vm._e(), _vm._v(" "), (form.type === 'mild') ? _c('x-switch', {
      key: index,
      attrs: {
        "id": "switch",
        "title": form.name + (_vm.mild ? ('<span class=' + 'switch-content' + '>' + form.label + '</span>') : '')
      },
      on: {
        "on-change": _vm.getFee
      },
      model: {
        value: (_vm.mild),
        callback: function($$v) {
          _vm.mild = $$v
        },
        expression: "mild"
      }
    }) : _vm._e(), _vm._v(" "), (form.type === 'mildCoverage' && _vm.mild) ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name,
        "value": _vm.mildCoverage
      }
    }) : _vm._e(), _vm._v(" "), (form.type === 'occupation') ? _c('cell', {
      key: index,
      staticClass: "occupation",
      attrs: {
        "title": form.name
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.occupationType) + "类")]), _c('x-button', {
      staticClass: "holderOccupationName",
      staticStyle: {
        "margin-left": "4px"
      },
      attrs: {
        "occupationtype": "1-6",
        "mini": ""
      }
    }, [_vm._v("查询职业")])], 1) : _vm._e()]
  }), _vm._v(" "), (this.$store.state.measure.success && this.$store.state.measure.baseBackMoney) ? _c('div', {
    staticClass: "back-money"
  }, [_c('p', [_vm._v("您将获得的保障利益是：")]), _vm._v(" "), _c('p', [_vm._v("1."), _c('a', [_vm._v("每" + _vm._s((_vm.paymentMode === 1 ? '年' : '月')))]), _vm._v("交"), _c('a', [_vm._v(_vm._s(this.$store.state.measure.basePremium * this.$store.state.order.coverage / 100) + "元")]), _vm._v("，交费满5年后开始领取，"), _c('a', [_vm._v("每" + _vm._s((_vm.paymentMode === 1 ? '年' : '月')))]), _vm._v("领取"), _c('a', [_vm._v(_vm._s(this.$store.state.measure.baseBackMoney * this.$store.state.order.coverage / 100) + "元")]), _vm._v("至终身，若不领取则自动进入累计生息账户；")]), _vm._v(" "), _c('p', [_vm._v("2.保障期限内，若被保险人不幸身故，将返还现金价值与已交保险费的较大者给法定受益人。")])]) : _vm._e()], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65e6be63","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Measure.vue
// module id = 675
// module chunks = 1